module.exports = __webpack_public_path__ + "img/红色的气球.a0ccdab6.png";